import { render, staticRenderFns } from "./RgpdConsentDialog.vue?vue&type=template&id=b3ed7b5a&"
import script from "./RgpdConsentDialog.vue?vue&type=script&lang=ts&"
export * from "./RgpdConsentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports